import PropTypes from 'prop-types';
import { List } from 'immutable';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import { RIGHT_ALIGNED, WidgetLocationProp } from '../constants/WidgetLocations';
import WidgetHeader from './WidgetHeader';
import VisitorWidgetStyleWrapper from '../../presentation-components/VisitorWidgetStyleWrapper';
import styled from 'styled-components';
import WidgetViews from '../proptypes/WidgetViews';
import { THREAD_VIEW } from '../constants/views';
import { getBrandStyle } from '../util/color';
import KBNavigation from './KBNavigation';
import { KBSearchProvider } from '../../knowledge-base/context/KBSearchProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetBodyDiv = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDiv"
})(["display:flex;flex-direction:column;height:100%;background-color:#fff;overflow:auto;border-start-end-radius:10px;"]);
export const WidgetBodyDivWrapper = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDivWrapper"
})(["flex:1;min-height:0;display:flex;flex-direction:column;", ";"], ({
  $background
}) => getBrandStyle($background));
const VisitorWidget = ({
  backButtonDisabled,
  browserWindowHeight,
  browserWindowWidth,
  chatHeadingConfig,
  chatHeadingResponders,
  children,
  closeWidget,
  coloring,
  createNewThread,
  customHeaderText = null,
  endChat,
  inline = false,
  isThreadAssigned = false,
  isThreadClosed = false,
  isThreadPersisted = false,
  isThreadStarted = false,
  kbArticleDeepLink,
  restorePreviousViewFromKBArticle,
  mobile = false,
  navigateToKnowledgeBaseArticle,
  navigateBack,
  officeHoursMessage,
  setWidgetSize,
  showAvailabilityMessage,
  showBackButton,
  size = 'default',
  style,
  toggleWidgetSizeForKBArticle,
  typicalResponseTimeMessage,
  unseenThreadsCountExcludingCurrentThread,
  view = THREAD_VIEW,
  viewKBArticleExpanded,
  widgetLocation = RIGHT_ALIGNED,
  widgetSize,
  updateView,
  kbNavigationEnabled,
  isUngatedForCloseThread = false
}) => {
  return /*#__PURE__*/_jsx(VisitorWidgetStyleWrapper, {
    browserWindowHeight: browserWindowHeight,
    browserWindowWidth: browserWindowWidth,
    inline: inline,
    size: size,
    style: style,
    mobile: mobile,
    widgetLocation: widgetLocation,
    widgetSize: widgetSize,
    children: /*#__PURE__*/_jsxs(KBSearchProvider, {
      children: [/*#__PURE__*/_jsx(WidgetHeader, {
        backButtonDisabled: backButtonDisabled,
        browserWindowHeight: browserWindowHeight,
        chatHeadingConfig: chatHeadingConfig,
        coloring: coloring,
        chatHeadingResponders: chatHeadingResponders,
        createNewThread: createNewThread,
        customHeaderText: customHeaderText,
        inline: inline,
        isThreadAssigned: isThreadAssigned,
        isThreadClosed: isThreadClosed,
        isThreadPersisted: isThreadPersisted,
        isThreadStarted: isThreadStarted,
        kbArticleDeepLink: kbArticleDeepLink,
        restorePreviousViewFromKBArticle: restorePreviousViewFromKBArticle,
        mobile: mobile,
        navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
        navigateBack: navigateBack,
        officeHoursMessage: officeHoursMessage,
        onClose: closeWidget,
        onEndChat: endChat,
        toggleWidgetSizeForKBArticle: toggleWidgetSizeForKBArticle,
        setWidgetSize: setWidgetSize,
        showAvailabilityMessage: showAvailabilityMessage,
        showBackButton: showBackButton,
        typicalResponseTimeMessage: typicalResponseTimeMessage,
        unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
        view: view,
        viewKBArticleExpanded: viewKBArticleExpanded,
        isUngatedForCloseThread: isUngatedForCloseThread
      }), /*#__PURE__*/_jsx(WidgetBodyDivWrapper, {
        $background: coloring.accentColor,
        kbNavigationEnabled: kbNavigationEnabled,
        children: /*#__PURE__*/_jsx(WidgetBodyDiv, {
          children: children
        })
      }), kbNavigationEnabled && /*#__PURE__*/_jsx(KBNavigation, {
        coloring: coloring,
        updateView: updateView,
        view: view
      })]
    })
  });
};
VisitorWidget.propTypes = {
  backButtonDisabled: PropTypes.bool,
  browserWindowHeight: PropTypes.number.isRequired,
  browserWindowWidth: PropTypes.number.isRequired,
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List),
  children: PropTypes.node.isRequired,
  closeWidget: PropTypes.func,
  coloring: PropTypes.object.isRequired,
  createNewThread: PropTypes.func,
  customHeaderText: PropTypes.string,
  endChat: PropTypes.func,
  inline: PropTypes.bool.isRequired,
  isThreadAssigned: PropTypes.bool.isRequired,
  isThreadClosed: PropTypes.bool,
  isThreadPersisted: PropTypes.bool,
  isThreadStarted: PropTypes.bool,
  isUngatedForCloseThread: PropTypes.bool,
  kbArticleDeepLink: PropTypes.string,
  kbNavigationEnabled: PropTypes.bool,
  mobile: PropTypes.bool.isRequired,
  navigateBack: PropTypes.func,
  navigateToKnowledgeBaseArticle: PropTypes.func,
  officeHoursMessage: PropTypes.string,
  restorePreviousViewFromKBArticle: PropTypes.func,
  setWidgetSize: PropTypes.func,
  showAvailabilityMessage: PropTypes.bool,
  showBackButton: PropTypes.bool.isRequired,
  size: PropTypes.string,
  style: PropTypes.object,
  toggleWidgetSizeForKBArticle: PropTypes.func,
  typicalResponseTimeMessage: PropTypes.string,
  unseenThreadsCountExcludingCurrentThread: PropTypes.number,
  updateView: PropTypes.func,
  view: WidgetViews,
  viewKBArticleExpanded: PropTypes.bool,
  widgetLocation: WidgetLocationProp,
  widgetSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }).isRequired
};
VisitorWidget.displayName = 'VisitorWidget';
export default VisitorWidget;